<template lang="pug">
    MatchMedia(v-slot='{ screenSM }')
        div.select-filter-control
            tabs-control(v-if="screenSM" :tabs="tabs" @input="changeValue")
            div.select-filter-control__head(v-else @click="openOptions" ref="head")
                svg-icon(iconId="filter-icon")
                div.select-filter-control__selected-name {{ currentOption.name }}
                svg-icon(iconId="expand-button")
</template>

<script>
import { MatchMedia } from 'vue-component-media-queries'
import eventBus from '../../lib/event-bus'
import events from '../../lib/events'
import modalsList from '../modals/modals-list'

export default {
    name: 'select-filter-control',
    components: {
        MatchMedia,
    },
    props: {
        value: {
            type: String,
            required: true,
        },
        options: {
            type: Array,
            required: true,
        },
    },
    computed: {
        tabs() {
            return this.options.map(o => ({
                name: o.value,
                label: o.name,
                iconId: o.iconId,
            }))
        },
        currentOption() {
            return this.options.find(o => o.value == this.value)
        },
    },
    methods: {
        changeValue(val) {
            this.$emit('input', val)
        },
        openOptions() {
            eventBus.$emit(events.OPEN_MODAL, modalsList.SELECT_OPTION, {
                element: this.$refs.head,
                options: this.options,
                selected: this.value,
                handler: this.selectOption,
                wide: true,
            })
        },
        selectOption(option) {
            this.changeValue(option.value)
        },
    },
}
</script>
